/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

export const styles = css`
  :host {
    display: flex;
    height: 100%;
    width: 100%;
  }

  .panel-group {
    display: flex;
    height: 100%;
    width: 100%;
  }

  :host([placement='right']) .panel-group {
    flex-direction: row-reverse;
  }

  .sidebar-container {
    display: flex;
    flex-shrink: 0;
  }

  .panel-container {
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
`;

export default [styles];
